'use client';

import { useState } from 'react';

import { carBatteryLanding, motorBatteryLanding } from '@/constants/routes';

import { ShelfHeader } from '../../../ProductShelf/_components/ShelfHeader';
import { ShelfTabs } from '../../../ProductShelf/_components/ShelfTabs';
import { BatteryTabsProps } from './models';

const BATTERY_TABS = [
    { id: 'car', label: 'باتری خودرو', href: carBatteryLanding },
    { id: 'motor', label: 'باتری موتورسیکلت', href: motorBatteryLanding }
];

export const BatteryTabs = ({ carProducts, motorProducts }: BatteryTabsProps) => {
    const [activeId, setActiveId] = useState('car');
    const activeTab = BATTERY_TABS.find((tab) => tab.id === activeId)!;

    return (
        <section aria-label='باتری خودرو و موتورسیکلت' className='px-4 py-10 md:py-16'>
            <ShelfHeader
                badge='باتری خودرو و موتور'
                title='باتری مناسب وسیله‌ات رو پیدا کن'
                subtitle='آمپر، برند و گارانتی رو مقایسه کن و باتری مناسب خودرو یا موتورت رو انتخاب کن.'
                href={activeTab.href}
                linkLabel={`همهٔ ${activeTab.label}`}
            />
            <div className='mb-5 md:mb-6'>
                <ShelfTabs label='نوع وسیله' tabs={BATTERY_TABS} activeId={activeId} onSelect={(tab) => setActiveId(tab.id)} />
            </div>
            <div key={activeId}>{activeId === 'car' ? carProducts : motorProducts}</div>
        </section>
    );
};
